import { Modal } from "@nike/eds";
import RocketIcon from "../rocket";

const DivertFromUKTriggeredModal = ({
    isOpen, setIsOpen
}) => {
    return <Modal isOpen={isOpen}
                onDismiss={() => setIsOpen(false)}
                headerSlot={"UK divert increment triggered"}>
            <div>
              <div>
                Please note: processing the event(s) will take some time
              </div> 
              <RocketIcon />
            </div> 
           </Modal>
}

export default DivertFromUKTriggeredModal;